import React, { ReactNode, useState } from 'react';

import { NotionBlock } from '@Models';
import { createColumnResizeHandler } from './helpers';

interface ColumnListProps {
  columns: NotionBlock[];
  renderColumn: (column: NotionBlock) => ReactNode;
}

const ColumnList = ({ columns, renderColumn }: ColumnListProps) => {
  // Initialize widths based on width_ratio from Notion
  const initialWidths = columns.map((col) => (col.content.width_ratio || 0.5) * 100);
  const [columnWidths, setColumnWidths] = useState<number[]>(initialWidths);

  return (
    <div className="column-container my-4 w-full group/columns overflow-hidden">
      <div className="flex gap-2">
        {columns.map((column, index) => (
          <React.Fragment key={column.id}>
            <div className="min-w-0 overflow-hidden" style={{ width: `${columnWidths[index]}%` }}>
              {renderColumn(column)}
            </div>

            {/* Resizer handle between columns */}
            {index < columns.length - 1 && (
              <div
                className="w-1 hover:cursor-col-resize bg-transparent group-hover/columns:bg-gray-400 group-hover/columns:rounded-md transition-colors flex-shrink-0"
                onMouseDown={createColumnResizeHandler(index, columnWidths, setColumnWidths)}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ColumnList;
